const de = {
  translation: {
    salutation: "Hallo",
    introduction: "Ich bin",
    introudction_job_title: "und ich bin",
    developer: "Entwickler",
    download: "Herunterladen",
    cv: "Lebenslauf",
    select: "Auswählen",
    experiance_years: "{{years}} Jahre",
    of_experiance: "Erfahrung",
    my_portofolio: "Mein Portfolio",
    portofolio: "Projekte",
    testimonials: "Freiwilligenarbeit",
    all: "Alle",
    about: "Über mich",
    services: "Services",
    how_i_can_help: "Wie ich helfen kann",
    skill_level_question: "Was ist mein Kenntnisstand",
    see_more: "Mehr anzeigen",
    achievements: "Erfolge",
    personal_info: "Persönliche Informationen",
    experience: "Erfahrung",
    education: "Bildung",
    skills_and_technology: "Fähigkeiten und Technologie",
    hide: "Ausblenden",
    get_in_touch: "Kontakt aufnehmen",
    send_message: "Nachricht senden",
    message: "Nachricht",
    subject: "Betreff",
    your_name: "Dein Name",
    email_address: "E-Mail-Adresse",
    talk_statment: "Lassen Sie uns über Ihr Softwareprojekt sprechen",
    like_form_question: "Bevorzugen Sie direkten Kontakt",
    send_me: "Schicken Sie mir eine",
    email: "E-Mail",
    language: "Sprache",
    home_page: "Startseite",
    me: "Ich",
    my_experience: "Meine Erfahrung",
    coming_soon: "Kommt bald",
    this_page_is_under_construction: "Diese Seite befindet sich im Aufbau",
    is_required_field: "{{field}} ist ein Pflichtfeld",
  },
};

export default de;
